module.exports = __webpack_public_path__ + "img/logo.e8abdbc9.jpeg";